import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';
import BackButton from '../Buttons/BackButton';
import TextInput from '../Forms/TextInput';

const ContentCreationHeader = ({ contentTitle, onTitleChange, onSaveClick, loading, disableSubmit, children }) => {
  let titleTextInput;
  if (contentTitle) {
    titleTextInput = (
      <div className="content-title flex-center">
        <TextInput
          name="title"
          value={contentTitle}
          onChange={onTitleChange}
        />
      </div>
    );
  }

  let disabled = disableSubmit;
  if (loading === true) {
    disabled = true;
  }

  return (
    <div className="content-creation-header position-fixed">
      <div className="back-btn-container flex-center">
        <BackButton href="/locker/my-content" />
      </div>

      {titleTextInput}

      {children}

      <div className="flex-center save-btn-container">
        <Button type="submit" disabled={disabled} loading={loading} onClick={e => onSaveClick(e)}>Save</Button>
      </div>
    </div>
  );
};

ContentCreationHeader.propTypes = {
  contentTitle: PropTypes.string,
  onTitleChange: PropTypes.func,
  onSaveClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default ContentCreationHeader;



// WEBPACK FOOTER //
// ./library/app/components/Global/Misc/ContentCreationHeader.js